import Vue from "vue";

export const formatCNPJ = value =>
  value
    .toUpperCase()
    .replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/, "$1.$2.$3/$4-$5");

export const formatCPF = value =>
  value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");

export const formatDocument = value =>
  value.toUpperCase().replace(/[^0-9A-Z]/g, '').length > 11
    ? formatCNPJ(value.toUpperCase().replace(/[^0-9A-Z]/g, ''))
    : formatCPF(value.replace(/\D/g, ''));

Vue.filter("document", value => {
  if (!value) {
    return "";
  }

  return formatDocument(value);
});
